module.exports = __webpack_public_path__ + "static/media/Motorola Moto 360 Men Silver + Cognac Open.496d54c3.png";